import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) => api.get("/account-groups", config),
    create: (data: object, config: AxiosRequestConfig) =>
        api.post("/account-groups", data, config),
    delete: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/account-groups/${url.id}`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/account-groups/${url.id}`, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/account-groups/${url.id}`, data, config),
};

export default requests;
